import React, { useEffect, useState } from 'react';
import Icon from '../../../../ui/icon/icon';
import LoadingCell from '../../../../ui/table/cells/loadingCell/loadingCell';

import './readCell.scss';

const ReadCell = (props) => {
  if (props.rowType === "groupHeader") {
    return null;
  }

  if (props.dataItem[props.field] === undefined && props.treelist) return <td></td>;
  if (props.dataItem[props.field] === undefined) return <LoadingCell />;
  const [isRead, setIsRead] = useState(props.dataItem.isRead);

  useEffect(() => {
    setIsRead(props.dataItem.isRead);
  }, [isRead]);

  return (
    <td>
      <div className='read-cell'>
        <Icon className='read-cell-icon' name={`${isRead && 'fas fa-circle-check'}`} />
      </div>
    </td>
  );
};

export default ReadCell;
